export const keysList = [
  '##attribute#invoice#uds_payerbankaccountid',
  '##attribute#uds_eventinformation#uds_eventname',
  '##attribute#uds_eventinformation#uds_productevent',
  '##attribute#uds_eventinformation#uds_eventstatus',
  '##attribute#uds_eventinformation#uds_location',
  '##attribute#uds_eventinformation#uds_eventdescription',
  '##attribute#uds_eventinformation#uds_plannedstartingtime',
  '##attribute#uds_eventinformation#uds_plannedendingtime',
  '##attribute#uds_eventinformation#uds_plannedduration',
  '##attribute#uds_eventinformation#uds_actualstartingtime',
  '##attribute#uds_eventinformation#uds_actualendingtime',
  '##attribute#uds_eventinformation#uds_actualduration',
  '##attribute#uds_communicationmessage#uds_productid',
  '##attribute#uds_communicationmessage#uds_cooperativeid',
  '##attribute#uds_communicationmessage#uds_issms',
  '##attribute#uds_communicationmessage#uds_isemail',
  '##attribute#uds_communicationmessage#uds_isportalmessage',
  '##attribute#uds_communicationmessage#uds_showinfloorapp',
  '##attribute#uds_communicationmessage#uds_distributedon',
  '##attribute#uds_communicationmessage#modifiedon',
  '##attribute#uds_communicationmessage#createdon',
  '##attribute#uds_communicationmessage#uds_eventinformation',
  '##attribute#invoice#uds_invoicetype',
  '##attribute#invoice#uds_sellerinvoicenumber',
  '##attribute#invoice#customerid',
  '##attribute#invoice#uds_sellerid',
  '##attribute#invoice#uds_sellerbankaccountid',
  '##attribute#invoice#uds_accountingdate',
  '##attribute#invoice#uds_invoicedate',
  '##attribute#invoice#uds_paymentduedate',
  '##attribute#invoice#uds_brc_recurrence',
  '##attribute#invoice#uds_vatratecode',
  '##attribute#invoice#uds_vatamount',
  '##attribute#invoice#uds_amountvatexcluding',
  '##attribute#invoice#uds_totalamountvatincluding',
  '##attribute#invoice#uds_approvalstatus',
  '##attribute#invoice#uds_ledgeringstatus',
  '##attribute#invoice#uds_paymentstatus',
  '##attribute#incident#customerid',
  '##attribute#incident#uds_buildingid',
  '##attribute#incident#uds_buildingaddress',
  '##attribute#incident#uds_spaceid',
  '##attribute#incident#uds_spacetypedescriptioncode',
  '##attribute#incident#uds_estimatedtiming',
  '##attribute#incident#uds_projectstatuscode',
  '##attribute#incident#statuscode',
  '##attribute#incident#uds_includeincoopreport',
  '##attribute#incident#uds_portaldescription',
  '##attribute#account#uds_hallwayscnt',
  '##attribute#account#uds_levelscnt',
  '##attribute#account#uds_parkingspacestotal',
  '##attribute#account#uds_parkingspacesgarage',
  '##attribute#uds_bankaccount#uds_name',
  '##attribute#uds_bankaccount#uds_operatorid',
  '##attribute#uds_bankaccount#uds_balance',
  '##attribute#uds_bankaccount#uds_balancedate',
  '##attribute#incident#title',
  '##attribute#incident#createdon',
  '##attribute#incident#modifiedon',
  '##attribute#incident#uds_approvalstatus',
  '##attribute#uds_communicationmessage#uds_name',
  '##attribute#uds_communicationmessage#uds_description',
  '##attribute#uds_communicationmessage#statuscode',
  '##attribute#uds_portalmessage#subject',
  '##attribute#uds_portalmessage#description',
  '##attribute#uds_portalmessage#createdon',
  '##attribute#uds_portalmessage#modifiedon',
  '##attribute#uds_space#uds_building',
  '##attribute#uds_space#uds_stairway',
  '##attribute#uds_space#uds_floor',
  '##attribute#uds_space#uds_spacetypecode',
  '##attribute#uds_ledgeraccountevent#uds_ledgeraccountid',
  '##attribute#uds_ledgeraccountevent#uds_eventdate',
  '##attribute#uds_ledgeraccountevent#uds_debet',
  '##attribute#uds_ledgeraccountevent#uds_credit',
  '##attribute#uds_ledgeraccountevent#uds_description',
  '##attribute#uds_ledgeraccountevent#uds_costlocationid',
  '##attribute#invoice#uds_invoicenumber',
  '##attribute#invoice#name',
  '##attribute#invoice#uds_payerpartynames',
  '##attribute#uds_consumption#uds_meterid',
  '##attribute#uds_consumption#uds_date',
  '##attribute#uds_consumption#uds_value',
  '##attribute#uds_consumption#uds_usage',
  '##attribute#account#name',
  '##attribute#account#uds_busidentitycode',
  '##attribute#account#uds_constructioncompletionyear',
  '##attribute#account#uds_vatregistered',
  '##attribute#account#uds_registeredtobusinessregister',
  '##attribute#account#uds_amounttotal',
  '##attribute#account#uds_lastregisteredday',
  '##attribute#account#address1_line1',
  '##attribute#account#address1_line2',
  '##attribute#account#address1_line3',
  '##attribute#account#address1_postalcode',
  '##attribute#account#address1_city',
  '##attribute#account#address1_country',
  '##attribute#account#address1_postofficebox',
  '##attribute#account#uds_livingspacesquaremeters',
  '##attribute#account#uds_buildingrightlivingspaceunused',
  '##attribute#account#uds_otherspaceused',
  '##attribute#account#uds_cubicmeters',
  '##attribute#account#uds_type',
  '##attribute#account#uds_parkingspacegovernancerules',
  '##attribute#uds_lot#uds_name',
  '##attribute#uds_lot#uds_lessorid',
  '##attribute#uds_lot#uds_originallotexistingid',
  '##attribute#uds_lot#uds_official',
  '##attribute#uds_lot#uds_originallotnew',
  '##attribute#uds_lot#uds_isrentedowned',
  '##attribute#uds_lot#uds_reclaimoflotsharecode',
  '##attribute#uds_lot#uds_rentamount',
  '##attribute#uds_lot#uds_rentfeeadjustmentbasis',
  '##attribute#uds_lot#uds_rentcontractenddate',
  '##attribute#uds_lot#uds_countycity',
  '##attribute#uds_lot#uds_block',
  '##attribute#uds_lot#uds_neihgborhoodvillage',
  '##attribute#uds_lot#uds_lotestate',
  '##attribute#uds_lot#uds_postnumber',
  '##attribute#uds_lot#uds_streetaddress',
  '##attribute#uds_lot#uds_approved',
  '##attribute#uds_lot#uds_unused',
  '##attribute#uds_lot#uds_used',
  '##attribute#uds_lot#uds_parkingspacespermitted',
  '##attribute#uds_lot#uds_lotsquaremeters',
  '##attribute#uds_building#uds_name',
  '##attribute#uds_building#uds_constructionstartingyear',
  '##attribute#uds_building#uds_constructioncompletionyear',
  '##attribute#uds_building#uds_buildinginaugurationyear',
  '##attribute#uds_building#uds_buildingtypecode',
  '##attribute#uds_building#uds_desc',
  '##attribute#uds_building#uds_straddress',
  '##attribute#uds_building#uds_postalarea',
  '##attribute#uds_building#uds_postalcode',
  '##attribute#uds_building#uds_volume',
  '##attribute#uds_building#uds_floorsnumberof',
  '##attribute#uds_building#uds_stairwaysnumberof',
  '##attribute#uds_building#uds_buildingrightlivingspaceused',
  '##attribute#uds_building#uds_buildingrightfloorspaceused',
  '##attribute#uds_building#uds_permittedbuildingright',
  '##attribute#uds_building#uds_buildingrightlivingspaceunused',
  '##attribute#uds_building#uds_buildingrightapproved',
  '##attribute#uds_building#uds_heatingenergytype',
  '##attribute#uds_building#uds_heatingsystype',
  '##attribute#uds_building#uds_airconditionsystype',
  '##attribute#uds_building#uds_cabeltvprovider',
  '##attribute#uds_building#uds_communicationnetworktype',
  '##attribute#uds_building#uds_coolingsystemtype',
  '##attribute#uds_building#uds_tvantennatype',
  '##attribute#uds_building#uds_tvantennasystemproviderid',
  '##attribute#uds_space#uds_usagetype',
  '##attribute#uds_space#uds_numberofrooms',
  '##attribute#uds_space#uds_petstype',
  '##attribute#uds_cooperativecontractline#uds_sharenumbers',
  '##attribute#uds_cooperativecontractline#uds_shareamount',
  '##attribute#uds_cooperativecontractline#uds_sharenumberofvotes',
  '##attribute#task#uds_executorid',
  '##attribute#task#uds_due',
  '##attribute#task#statuscode',
  '##attribute#task#prioritycode',
  '##attribute#uds_space#uds_spacedefiency',
  '##attribute#account#uds_businessspaceused',
  '##attribute#uds_communicationmessage#uds_floorappmessageduration',
  '##attribute#uds_space#uds_cooperativeid',
  '##attribute#incident#uds_requesttype',
  '##attribute#incident#prioritycode',
  '##attribute#incident#uds_resolutiondescription',
  '##attribute#task#subject',
  '##attribute#contact#emailaddress1',
  '##attribute#contact#mobilephone',
  '##attribute#contact#fullname',
  '##attribute#contact#uds_marketingpermission',
  '##attribute#incident#uds_buildingpostalarea',
  '##attribute#incident#uds_buildingpostalcode',
  '##attribute#incident#uds_masterkeyallowed',
  '##attribute#incident#uds_repairformneedtobeagreed',
  '##attribute#incident#uds_appartmenthasadditionallock',
  '##attribute#task#uds_resolutiondescription',
  '##attribute#task#description',
  '##attribute#task#modifiedon',
  '##attribute#task#createdon',
  '##attribute#task#uds_customerdescription',
  '##attribute#incident#uds_additionalnotes',
  '##attribute#incident#uds_needsendsms',
  '##attribute#incident#uds_needsendemail',
  '##attribute#contact#firstname',
  '##attribute#contact#lastname',
  '##attribute#contact#birthdate',
  '##attribute#contact#uds_tax',
  '##attribute#uds_space#uds_spacestatuscode',
  '##attribute#uds_space#uds_spacetypetext',
  '##attribute#connection#uds_registrationdate',
  '##attribute#connection#uds_ownershippercentage',
  '##attribute#uds_bankaccount#uds_isreimbursementaccount',
  '##attribute#uds_bankaccount#uds_iscommissionaccount',
  '##attribute#contact#uds_socialsecuritynumber',
  '##attribute#incident#uds_keyordertype',
  '##attribute#incident#uds_keysamount',
  '##attribute#incident#uds_typeofthekey',
  '##attribute#incident#uds_keynumber',
  '##attribute#incident#statecode',
  '##attribute#incident#uds_spaceid',
  '##attribute#incident#uds_aloituspiva',
  '##attribute#incident#uds_pttymispiv',
  '##attribute#incident#uds_descriptionofchange',
  '##attribute#incident#uds_putkity',
  '##attribute#incident#uds_shkty',
  '##attribute#incident#uds_kosteidentilojenmuutostyt',
  '##attribute#incident#uds_parveketailterassilasitus',
  '##attribute#incident#uds_huonejrjestyksenmuutokset',
  '##attribute#incident#uds_muumerkittvmuutosty',
  '##attribute#incident#uds_lattiapinnoitteenuusiminen',
  '##attribute#incident#uds_ilmalmppumpunasennus',
  '##attribute#incident#uds_muutavanomalnenmuutosty',
  '##attribute#incident#uds_maalaus',
  '##attribute#incident#uds_vliovienuusiminen',
  '##attribute#incident#uds_tapetointi',
  '##attribute#incident#uds_muuvhinenmuutosty',
  '##attribute#incident#uds_needsendsms',
  '##attribute#incident#uds_needsendemail',
];
